module.exports = {
	"pagination": {
		"ListCertificates": {
			"input_token": "NextToken",
			"limit_key": "MaxItems",
			"output_token": "NextToken",
			"result_key": "CertificateSummaryList"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/acm-2015-12-08.paginators.json
// module id = 1870
// module chunks = 0